import React from 'react';

import {Button, ButtonInterface, IconProps} from '@veneer/core';

import {ButtonLink} from '@br/mg-components';

import {ButtonLinkInterface} from '../Links/ButtonLink';
import {Panel} from '../Panel';
import {PanelTheme} from '../Panel/types';

import useStyles from './styles';

type Action = ButtonInterface | ButtonLinkInterface;

const Paper = ({
    children,
    icon: Icon,
    title,
    className = '',
    primaryAction,
    secondaryAction,
    componentTheme = 'default',
}: {
    children?: string;
    title?: string;
    icon?: React.JSXElementConstructor<IconProps>;
    className?: string;
    primaryAction?: Action;
    secondaryAction?: Action;
    componentTheme?: PanelTheme;
}) => {
    const styles = useStyles();

    const primaryProps: Action = {...primaryAction, appearance: 'secondary', className: styles.button, small: true};
    const secondaryProps: Action = {...secondaryAction, appearance: 'secondary', className: styles.button, small: true};

    const getComponent = (props: Action) => {
        if ('href' in props) {
            return <ButtonLink {...props} />;
        }
        return <Button {...props} />;
    };

    return (
        <Panel
            className={`${className} ${styles.card}`}
            componentTheme={componentTheme}
        >
            <div className={styles.contentWrapper}>
                {Icon && (
                    <Icon
                        className={styles.icon}
                        size={48}
                    />
                )}
                <h3 className={`${styles.title} subtitle-regular`}>{title}</h3>
                <div className={styles.textWrapper}>{children}</div>
                <div className={styles.actions}>
                    {primaryAction && getComponent(primaryProps)}
                    {secondaryAction && getComponent(secondaryProps)}
                </div>
            </div>
        </Panel>
    );
};

export default Paper;
